<section class="bg-gray-50 py-12 lg:py-16" lang="es-HN">
  <allas-margin-wrapper>
    <div class="lg:hidden space-y-4">
      <ng-container *ngTemplateOutlet="mobileAccordionSection; context: { 
        sectionKey: 'makes', 
        title: 'Marcas de Vehículos Populares', 
        items: popularMakes,
        itemTemplate: makeItemTemplate
      }"></ng-container>
      
      <ng-container *ngTemplateOutlet="mobileAccordionSection; context: { 
        sectionKey: 'models', 
        title: 'Modelos de Vehículos Populares', 
        items: popularModels,
        itemTemplate: modelItemTemplate
      }"></ng-container>
      
      <ng-container *ngTemplateOutlet="mobileAccordionSection; context: { 
        sectionKey: 'brands', 
        title: 'Marcas de Repuestos Populares', 
        items: popularBrands,
        itemTemplate: brandItemTemplate
      }"></ng-container>
      
      <ng-container *ngTemplateOutlet="mobileAccordionSection; context: { 
        sectionKey: 'advice', 
        title: 'Consejos y Guías', 
        items: adviceAndHowTos,
        itemTemplate: adviceItemTemplate
      }"></ng-container>
    </div>

    <div class="hidden lg:grid grid-cols-4 gap-12">
      <ng-container *ngTemplateOutlet="desktopColumn; context: { 
        title: 'Marcas de Vehículos Populares', 
        items: popularMakes,
        expanded: expandedMakes,
        toggleMethod: 'toggleMakes',
        itemTemplate: makeItemTemplate
      }"></ng-container>
      
      <ng-container *ngTemplateOutlet="desktopColumn; context: { 
        title: 'Modelos de Vehículos Populares', 
        items: popularModels,
        expanded: expandedModels,
        toggleMethod: 'toggleModels',
        itemTemplate: modelItemTemplate
      }"></ng-container>
      
      <ng-container *ngTemplateOutlet="desktopColumn; context: { 
        title: 'Marcas de Repuestos Populares', 
        items: popularBrands,
        expanded: expandedBrands,
        toggleMethod: 'toggleBrands',
        itemTemplate: brandItemTemplate
      }"></ng-container>
      
      <ng-container *ngTemplateOutlet="desktopColumn; context: { 
        title: 'Consejos y Guías', 
        items: adviceAndHowTos,
        expanded: expandedAdvice,
        toggleMethod: 'toggleAdvice',
        itemTemplate: adviceItemTemplate
      }"></ng-container>
    </div>
  </allas-margin-wrapper>

  <!-- Mobile Accordion Section Template -->
  <ng-template #mobileAccordionSection let-sectionKey="sectionKey" let-title="title" let-items="items" let-itemTemplate="itemTemplate">
    <div>
      <button
        (click)="onToggleSection(sectionKey)"
        class="w-full flex items-center justify-between p-4 text-left hover:bg-gray-50 transition-colors"
        [attr.aria-expanded]="expandedSections[sectionKey]"
        [attr.aria-controls]="'mobile-section-' + sectionKey"
      >
        <span class="font-medium text-gray-800 fs-condensed text-lg">
          {{ title }}
        </span>
        <lucide-icon
          [name]="expandedSections[sectionKey] ? chevronUpIcon : chevronDownIcon"
          class="w-5 h-5 text-gray-600"
        ></lucide-icon>
      </button>
      
      <div 
        *ngIf="expandedSections[sectionKey]" 
        class="px-4 pb-4"
        [id]="'mobile-section-' + sectionKey"
      >
        <ul class="space-y-3">
          <ng-container *ngFor="let item of items; trackBy: trackByItemName">
            <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"></ng-container>
          </ng-container>
        </ul>
      </div>
    </div>
  </ng-template>

  <!-- Desktop Column Template -->
  <ng-template #desktopColumn let-title="title" let-items="items" let-expanded="expanded" let-toggleMethod="toggleMethod" let-itemTemplate="itemTemplate">
    <div>
      <h2 class="text-lg font-bold text-gray-800 mb-6 fs-condensed">
        {{ title }}
      </h2>
      <ul class="space-y-3">
        <ng-container *ngFor="let item of (expanded ? items : items.slice(0, 5)); trackBy: trackByItemName">
          <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"></ng-container>
        </ng-container>
        
        <li *ngIf="!expanded && items.length > 5">
          <button
            (click)="toggleMethod === 'toggleMakes' ? toggleMakes() : toggleMethod === 'toggleModels' ? toggleModels() : toggleMethod === 'toggleBrands' ? toggleBrands() : toggleAdvice()"
            class="text-red-600 hover:text-red-700 font-medium transition-colors fs-condensed text-sm"
            aria-label="Ver más opciones"
          >
            Ver Más →
          </button>
        </li>
        
        <li *ngIf="expanded">
          <button
            (click)="toggleMethod === 'toggleMakes' ? toggleMakes() : toggleMethod === 'toggleModels' ? toggleModels() : toggleMethod === 'toggleBrands' ? toggleBrands() : toggleAdvice()"
            class="text-red-600 hover:text-red-700 font-medium transition-colors fs-condensed text-sm"
            aria-label="Ver menos opciones"
          >
            Ver Menos ↑
          </button>
        </li>
      </ul>
    </div>
  </ng-template>

  <!-- Item Templates -->
  <ng-template #makeItem let-item>
    <li>
      <a
        [href]="item.href"
        class="flex items-center gap-2 text-gray-600 hover:text-red-600 transition-colors fs-condensed text-sm leading-relaxed"
        [attr.aria-label]="'Ver ' + (item.name | smartCapitalize)"
      >
        {{ item.name | smartCapitalize }}
      </a>
    </li>
  </ng-template>

  <ng-template #modelItem let-item>
    <li>
      <a
        [href]="item.href"
        class="flex items-center gap-2 text-gray-600 hover:text-red-600 transition-colors fs-condensed text-sm leading-relaxed"
        [attr.aria-label]="'Ver ' + (item.name | smartCapitalize)"
      >
        {{ item.name | smartCapitalize }}
      </a>
    </li>
  </ng-template>

  <ng-template #brandItem let-item>
    <li>
      <a
        [href]="item.href"
        [class.text-gray-300]="!item.active"
        [class.text-gray-600]="item.active"
        class="flex items-center gap-2 hover:text-red-600 transition-colors font-inter text-sm leading-relaxed fs-condensed"
        [attr.aria-label]="'Ver ' + item.name + (item.active ? '' : ' (no disponible)')"
      >
        {{ item.name }}
      </a>
    </li>
  </ng-template>

  <ng-template #adviceItem let-item>
    <li>
      <a
        [href]="item.href"
        class="text-gray-600 hover:text-red-600 transition-colors text-sm leading-relaxed fs-condensed"
        [attr.aria-label]="'Leer ' + item.name"
      >
        {{ item.name }}
      </a>
    </li>
  </ng-template>
</section>
